document.addEventListener("click", (event) => {
	if (event.target.closest(".filterschalter")) {
		const schalter = event.target.closest(".filterschalter")
		const filterbox = schalter.closest(".filterbox")
		const divAufgaben = document.querySelector(".aufgabencontainer")

		// Rangepicker (un-)sichtbar machen
		if (schalter.closest(".filter_zeitraum")) {
			const div = filterbox.querySelector(".zeit_setting")
			div.classList.toggle("hidden")
		}

		// Zeitraum löschen, wenn Zeitraum-Filter deaktiviert wird
		if (schalter.closest(".filter_zeitraum.\\!ring-highlight")) {
			const input = filterbox.querySelectorAll("input")
			input.forEach((inp) => {
				inp.value = ""
			})
		}
		// Filter aktivieren/deaktivieren
		filterbox.classList.toggle("!ring-2")
		filterbox.classList.toggle("!ring-highlight")
		schalter.querySelector("svg").classList.toggle("!fill-highlight")

		// Filter ausfuehren
		filter_aufgaben(divAufgaben)
	}

	if (event.target.closest(".filterdropdown_zustaendig div")) {
		const filterbox = event.target.closest(".filter_eigene"),
			namelink = event.target.closest(".filterdropdown_zustaendig div"),
			selected_name = filterbox.querySelector(".selected_zustaendig"),
			divAufgaben = document.querySelector(".aufgabencontainer")

		selected_name.dataset.userid = namelink.dataset.userid
		selected_name.innerHTML = namelink.innerHTML

		// Filter ausfuehren, wenn Filter aktiv
		if (filterbox.classList.contains("!ring-highlight")) {
			filter_aufgaben(divAufgaben)
		}
	}
})

document.addEventListener("change", (event) => {
	if (event.target.closest(".filter_zeitraum .date_von") || event.target.closest(".filter_zeitraum .date_bis")) {
		const divAufgaben = document.querySelector(".aufgabencontainer")
		filter_aufgaben(divAufgaben)
	}
})

// #############################################################################
// Filtermethode, die alle einzelnen Filter aufruft
// #############################################################################
const filter_aufgaben = (divAufgaben) => {
	if (divAufgaben) {
		// Aufgaben
		const aufgaben = divAufgaben.querySelectorAll(".dashboard_aufgabe")
		// Boolean-Werte, ob Filter aktiv
		const faehnchen = document.querySelector(".filter_faehnchen").classList.contains("!ring-highlight")
		const icon = document.querySelector(".filter_eigene").classList.contains("!ring-highlight")
		//const heute = document.querySelector(".filter_heute").classList.contains("!ring-highlight");
		//const woche = document.querySelector(".filter_woche").classList.contains("!ring-highlight");
		// Zeitraum-Range
		const zeitraum = valid_range(divAufgaben)
		// User
		const user = document.querySelector(".filter_eigene .selected_zustaendig").dataset.userid

		aufgaben.forEach((aufgabe) => {
			const prio = parseInt(aufgabe.dataset.prio),
				frist = moment(aufgabe.dataset.frist),
				zustaendiger = aufgabe.dataset.zustaendiger

			aufgabe.classList.add("hidden")

			if (filter_faehnchen(faehnchen, prio)) return
			if (filter_eigene(icon, zustaendiger, user)) return
			//if (filter_heute(heute, frist)) return;
			//if (filter_woche(woche, frist)) return;
			if (filter_zeitraum(zeitraum, frist)) return

			aufgabe.classList.remove("hidden")
		})
	}
}

// #############################################################################
// Prio - Filter
// #############################################################################
const filter_faehnchen = (faehnchen, prio) => {
	return faehnchen && prio == 0
}

// #############################################################################
// Eigene - Filter
// #############################################################################
const filter_eigene = (icon, zustaendiger, user) => {
	return icon && zustaendiger != user
}

// #############################################################################
// Heute - Filter
// #############################################################################
const filter_heute = (heute, frist) => {
	if (heute && !frist.isValid()) return true
	const today = moment().endOf("day")
	return heute && frist.diff(today) > 0
}

// #############################################################################
// Diese Woche - Filter
// #############################################################################
const filter_woche = (woche, frist) => {
	if (woche && !frist.isValid()) return true
	const dayseven = moment().add(7, "d")
	return woche && frist.diff(dayseven) > 0
}

// #############################################################################
// Zeitraum - Filter
// #############################################################################
const filter_zeitraum = (zeitraum, frist) => {
	return zeitraum.length > 0 && !date_in_range(zeitraum, frist)
}

// #############################################################################
// SONSTIGE METHODEN
// #############################################################################
const valid_range = (divAufgaben) => {
	const start = document.querySelector(".date_von").value
	const ende = document.querySelector(".date_bis").value
	const startdatum = moment(start, "D.M.YYYY")
	const enddatum = moment(ende, "D.M.YYYY")
	let range = []

	if (startdatum.isValid() && enddatum.isValid()) {
		range.push(moment(startdatum), moment(enddatum))
	}

	return range
}

// #############################################################################
const date_in_range = (zeitraum, frist) => {
	return zeitraum[0].diff(frist) <= 0 && zeitraum[1].diff(frist) >= 0
}

// #############################################################################
// Automatisches Setzen von Daten in den Rangepicker
// #############################################################################
document.addEventListener("click", (event) => {
	if (event.target.closest(".buttonleiste div")) {
		const button = event.target.closest(".buttonleiste div"),
			input_von = document.querySelector(".date_von"),
			input_bis = document.querySelector(".date_bis")

		if (button.classList.contains("buttonheute")) {
			input_von.value = moment().format("DD.MM.YYYY")
			input_bis.value = moment().format("DD.MM.YYYY")
			input_von.dispatchEvent(new Event("change", { bubbles: true }))
		}

		if (button.classList.contains("buttonwoche")) {
			input_von.value = moment().format("DD.MM.YYYY")
			input_bis.value = moment().add(7, "d").format("DD.MM.YYYY")
			input_von.dispatchEvent(new Event("change", { bubbles: true }))
		}
	}
})
